import {
  Calendar,
  Mic,
  Star,
  Building,
  Link,
  MapPin,
  Image,
  List,
  Heart,
  Bookmark,
  Tag,
  FileText,
  Grid,
  Layers,
  Package,
  Users,
  Zap,
  Globe,
  // Additional meaningful icons for categories
  Clock,
  Bell,
  Settings,
  Award,
  Trophy,
  Medal,
  Coffee,
  Utensils,
  Briefcase,
  GraduationCap,
  Target,
  TrendingUp,
  BarChart,
  PieChart,
  DollarSign,
  CreditCard,
  ShoppingCart,
  Smartphone,
  Laptop,
  Monitor,
  Code,
  Database,
  Server,
  Cloud,
  Wifi,
  Camera,
  Video,
  Music,
  Headphones,
  Mail,
  Phone,
  MessageCircle,
  Send,
  Share2,
  Download,
  Upload,
  Edit,
  Plus,
  Check,
  X,
  Eye,
  Lock,
  Shield,
  AlertCircle,
  Info,
  CheckCircle,
  XCircle,
  Play,
  Pause,
  Square,
  Circle,
  Triangle,
  Lightbulb,
  Rocket,
  Compass,
  Flag,
  Home,
  Store,
  School,
  Hospital,
  Hotel,
  Car,
  Plane,
  Train,
  Palette,
  Brush,
  Wrench,
  Search,
  Folder,
  File,
  Archive,
  Printer,
} from "lucide-react";

// Unified icon options for all sections
export const ICON_OPTIONS = [
  { name: "calendar", icon: Calendar, displayName: "Calendar" },
  { name: "mic", icon: Mic, displayName: "Microphone" },
  { name: "star", icon: Star, displayName: "Star" },
  { name: "building", icon: Building, displayName: "Building" },
  { name: "link", icon: Link, displayName: "Link" },
  { name: "map_pin", icon: MapPin, displayName: "Map Pin" },
  { name: "image", icon: Image, displayName: "Image" },
  { name: "list", icon: List, displayName: "List" },
  { name: "heart", icon: Heart, displayName: "Heart" },
  { name: "bookmark", icon: Bookmark, displayName: "Bookmark" },
  { name: "tag", icon: Tag, displayName: "Tag" },
  { name: "file_text", icon: FileText, displayName: "File Text" },
  { name: "grid", icon: Grid, displayName: "Grid" },
  { name: "layers", icon: Layers, displayName: "Layers" },
  { name: "package", icon: Package, displayName: "Package" },
  { name: "users", icon: Users, displayName: "Users" },
  { name: "zap", icon: Zap, displayName: "Zap" },
  { name: "globe", icon: Globe, displayName: "Globe" },
  // New meaningful icons
  { name: "coffee", icon: Coffee, displayName: "Coffee" },
  { name: "utensils", icon: Utensils, displayName: "Food" },
  { name: "clock", icon: Clock, displayName: "Clock" },
  { name: "bell", icon: Bell, displayName: "Bell" },
  { name: "settings", icon: Settings, displayName: "Settings" },
  { name: "award", icon: Award, displayName: "Award" },
  { name: "trophy", icon: Trophy, displayName: "Trophy" },
  { name: "medal", icon: Medal, displayName: "Medal" },
  { name: "briefcase", icon: Briefcase, displayName: "Business" },
  { name: "graduation_cap", icon: GraduationCap, displayName: "Education" },
  { name: "target", icon: Target, displayName: "Target" },
  { name: "trending_up", icon: TrendingUp, displayName: "Growth" },
  { name: "bar_chart", icon: BarChart, displayName: "Analytics" },
  { name: "pie_chart", icon: PieChart, displayName: "Statistics" },
  { name: "dollar_sign", icon: DollarSign, displayName: "Finance" },
  { name: "credit_card", icon: CreditCard, displayName: "Payment" },
  { name: "shopping_cart", icon: ShoppingCart, displayName: "Commerce" },
  { name: "smartphone", icon: Smartphone, displayName: "Mobile" },
  { name: "laptop", icon: Laptop, displayName: "Technology" },
  { name: "monitor", icon: Monitor, displayName: "Display" },
  { name: "code", icon: Code, displayName: "Development" },
  { name: "database", icon: Database, displayName: "Data" },
  { name: "server", icon: Server, displayName: "Infrastructure" },
  { name: "cloud", icon: Cloud, displayName: "Cloud" },
  { name: "wifi", icon: Wifi, displayName: "Network" },
  { name: "camera", icon: Camera, displayName: "Photography" },
  { name: "video", icon: Video, displayName: "Video" },
  { name: "music", icon: Music, displayName: "Audio" },
  { name: "headphones", icon: Headphones, displayName: "Headphones" },
  { name: "mail", icon: Mail, displayName: "Email" },
  { name: "phone", icon: Phone, displayName: "Phone" },
  { name: "message_circle", icon: MessageCircle, displayName: "Chat" },
  { name: "send", icon: Send, displayName: "Send" },
  { name: "share", icon: Share2, displayName: "Share" },
  { name: "download", icon: Download, displayName: "Download" },
  { name: "upload", icon: Upload, displayName: "Upload" },
  { name: "edit", icon: Edit, displayName: "Edit" },
  { name: "plus", icon: Plus, displayName: "Add" },
  { name: "check", icon: Check, displayName: "Success" },
  { name: "x", icon: X, displayName: "Close" },
  { name: "eye", icon: Eye, displayName: "View" },
  { name: "lock", icon: Lock, displayName: "Security" },
  { name: "shield", icon: Shield, displayName: "Protection" },
  { name: "alert_circle", icon: AlertCircle, displayName: "Warning" },
  { name: "info", icon: Info, displayName: "Information" },
  { name: "check_circle", icon: CheckCircle, displayName: "Approved" },
  { name: "x_circle", icon: XCircle, displayName: "Error" },
  { name: "play", icon: Play, displayName: "Play" },
  { name: "pause", icon: Pause, displayName: "Pause" },
  { name: "square", icon: Square, displayName: "Square" },
  { name: "circle", icon: Circle, displayName: "Circle" },
  { name: "triangle", icon: Triangle, displayName: "Triangle" },
  { name: "lightbulb", icon: Lightbulb, displayName: "Innovation" },
  { name: "rocket", icon: Rocket, displayName: "Launch" },
  { name: "compass", icon: Compass, displayName: "Navigation" },
  { name: "flag", icon: Flag, displayName: "Flag" },
  { name: "home", icon: Home, displayName: "Home" },
  { name: "store", icon: Store, displayName: "Store" },
  { name: "school", icon: School, displayName: "School" },
  { name: "hospital", icon: Hospital, displayName: "Healthcare" },
  { name: "hotel", icon: Hotel, displayName: "Hospitality" },
  { name: "car", icon: Car, displayName: "Transportation" },
  { name: "plane", icon: Plane, displayName: "Travel" },
  { name: "train", icon: Train, displayName: "Transit" },
  { name: "palette", icon: Palette, displayName: "Design" },
  { name: "brush", icon: Brush, displayName: "Creative" },
  { name: "wrench", icon: Wrench, displayName: "Tools" },
  { name: "search", icon: Search, displayName: "Search" },
  { name: "folder", icon: Folder, displayName: "Folder" },
  { name: "file", icon: File, displayName: "Document" },
  { name: "archive", icon: Archive, displayName: "Archive" },
  { name: "printer", icon: Printer, displayName: "Print" },
];
